import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DashboardSearchBase } from './common/dashboard-search-base';

/**
 * Full-platform dashboard presentation.
 *
 * Search state and request serialisation live in the shared dashboard base so
 * alternate entitled workspaces can use the same backend contract without
 * adding presentation branches to this component.
 */
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent extends DashboardSearchBase {}
